/* tslint:disable */
/* eslint-disable */
/**
 * Time of Day/Day of Week API Documentation
 * End users can use the Time of Day/Day of Week (TOD/DOW) API to create unique user profiles (Home Profile, Work Profile, and so on) to manage various MMTel services.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AxiosInstance, AxiosPromise, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
import type { RequestArgs } from "../base";
// @ts-ignore
import { BASE_PATH, BaseAPI, COLLECTION_FORMATS, operationServerMap, RequiredError } from "../base";
// Some imports not used depending on template conditions
// @ts-ignore
import {
    assertParamExists,
    createRequestFunction,
    DUMMY_BASE_URL,
    serializeDataIfNeeded,
    setApiKeyToObject,
    setBasicAuthToObject,
    setBearerAuthToObject,
    setOAuthToObject,
    setSearchParams,
    toPathString,
} from "../common";
import type { Configuration } from "../configuration";

/**
 *
 * @export
 * @interface AnonymousCallRejection
 */
export interface AnonymousCallRejection {
    /**
     *
     * @type {Array<SelectiveDNEntry>}
     * @memberof AnonymousCallRejection
     */
    acrList?: Array<SelectiveDNEntry>;
    /**
     *
     * @type {string}
     * @memberof AnonymousCallRejection
     */
    inherit?: AnonymousCallRejectionInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof AnonymousCallRejection
     */
    pingRing?: boolean;
    /**
     *
     * @type {string}
     * @memberof AnonymousCallRejection
     */
    status?: AnonymousCallRejectionStatusEnum;
}

export const AnonymousCallRejectionInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type AnonymousCallRejectionInheritEnum = (typeof AnonymousCallRejectionInheritEnum)[keyof typeof AnonymousCallRejectionInheritEnum];
export const AnonymousCallRejectionStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type AnonymousCallRejectionStatusEnum = (typeof AnonymousCallRejectionStatusEnum)[keyof typeof AnonymousCallRejectionStatusEnum];

/**
 *
 * @export
 * @interface AutoAttendant
 */
export interface AutoAttendant {
    /**
     *
     * @type {string}
     * @memberof AutoAttendant
     */
    inherit?: AutoAttendantInheritEnum;
    /**
     *
     * @type {number}
     * @memberof AutoAttendant
     */
    rootVxmlFileId?: number;
    /**
     *
     * @type {string}
     * @memberof AutoAttendant
     */
    status?: AutoAttendantStatusEnum;
}

export const AutoAttendantInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type AutoAttendantInheritEnum = (typeof AutoAttendantInheritEnum)[keyof typeof AutoAttendantInheritEnum];
export const AutoAttendantStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type AutoAttendantStatusEnum = (typeof AutoAttendantStatusEnum)[keyof typeof AutoAttendantStatusEnum];

/**
 *
 * @export
 * @interface BlockCallCompletionBusySubscriber
 */
export interface BlockCallCompletionBusySubscriber {
    /**
     *
     * @type {string}
     * @memberof BlockCallCompletionBusySubscriber
     */
    inherit?: BlockCallCompletionBusySubscriberInheritEnum;
    /**
     *
     * @type {string}
     * @memberof BlockCallCompletionBusySubscriber
     */
    status?: BlockCallCompletionBusySubscriberStatusEnum;
}

export const BlockCallCompletionBusySubscriberInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type BlockCallCompletionBusySubscriberInheritEnum =
    (typeof BlockCallCompletionBusySubscriberInheritEnum)[keyof typeof BlockCallCompletionBusySubscriberInheritEnum];
export const BlockCallCompletionBusySubscriberStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type BlockCallCompletionBusySubscriberStatusEnum =
    (typeof BlockCallCompletionBusySubscriberStatusEnum)[keyof typeof BlockCallCompletionBusySubscriberStatusEnum];

/**
 *
 * @export
 * @interface BusyLampField
 */
export interface BusyLampField {
    /**
     *
     * @type {string}
     * @memberof BusyLampField
     */
    inherit?: BusyLampFieldInheritEnum;
    /**
     *
     * @type {string}
     * @memberof BusyLampField
     */
    status?: BusyLampFieldStatusEnum;
}

export const BusyLampFieldInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type BusyLampFieldInheritEnum = (typeof BusyLampFieldInheritEnum)[keyof typeof BusyLampFieldInheritEnum];
export const BusyLampFieldStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type BusyLampFieldStatusEnum = (typeof BusyLampFieldStatusEnum)[keyof typeof BusyLampFieldStatusEnum];

/**
 *
 * @export
 * @interface CallBarring
 */
export interface CallBarring {
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    allBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    directoryAssistanceBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    emergencyBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    fgbDialedCarrierBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    fgdDialedCarrierBarring?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallBarring
     */
    inherit?: CallBarringInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    intExhc?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    interLataBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    internationalBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    intraLataBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    localBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    mobileBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    nationalBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    nonNumericBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    nxxCallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    premiumServicesBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    roamNetwork?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    specialDialTone?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    tollFreeBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user10CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user11CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user12CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user13CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user1CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user2CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user3CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user4CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user5CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user6CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user7CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user8CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user9CallsBarring?: boolean;
}

export const CallBarringInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallBarringInheritEnum = (typeof CallBarringInheritEnum)[keyof typeof CallBarringInheritEnum];

/**
 *
 * @export
 * @interface CallBlocking
 */
export interface CallBlocking {
    /**
     *
     * @type {boolean}
     * @memberof CallBlocking
     */
    blkAll?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBlocking
     */
    blkInternational?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBlocking
     */
    blockRoamNetwork?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallBlocking
     */
    inherit?: CallBlockingInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallBlocking
     */
    roamOutsideCountry?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBlocking
     */
    specialDialTone?: boolean;
}

export const CallBlockingInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallBlockingInheritEnum = (typeof CallBlockingInheritEnum)[keyof typeof CallBlockingInheritEnum];

/**
 *
 * @export
 * @interface CallDeflection
 */
export interface CallDeflection {
    /**
     *
     * @type {string}
     * @memberof CallDeflection
     */
    fwdDN?: string;
    /**
     *
     * @type {string}
     * @memberof CallDeflection
     */
    fwdToType?: CallDeflectionFwdToTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CallDeflection
     */
    inherit?: CallDeflectionInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallDeflection
     */
    restrictIdBackward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallDeflection
     */
    restrictIdForward?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallDeflection
     */
    tas181Mode?: CallDeflectionTas181ModeEnum;
}

export const CallDeflectionFwdToTypeEnum = {
    Dn: "TO_DN",
    Vms: "TO_VMS",
    Attnd: "TO_ATTND",
} as const;

export type CallDeflectionFwdToTypeEnum = (typeof CallDeflectionFwdToTypeEnum)[keyof typeof CallDeflectionFwdToTypeEnum];
export const CallDeflectionInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallDeflectionInheritEnum = (typeof CallDeflectionInheritEnum)[keyof typeof CallDeflectionInheritEnum];
export const CallDeflectionTas181ModeEnum = {
    None: "TAS_181_NONE",
    NoFwinfo: "TAS_181_NO_FWINFO",
    WithFwinfo: "TAS_181_WITH_FWINFO",
} as const;

export type CallDeflectionTas181ModeEnum = (typeof CallDeflectionTas181ModeEnum)[keyof typeof CallDeflectionTas181ModeEnum];

/**
 *
 * @export
 * @interface CallForwardingBusy
 */
export interface CallForwardingBusy {
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingBusy
     */
    forwardDataCalls?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingBusy
     */
    forwardVoiceCalls?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallForwardingBusy
     */
    fwdDN?: string;
    /**
     *
     * @type {string}
     * @memberof CallForwardingBusy
     */
    fwdDNDataCall?: string;
    /**
     *
     * @type {string}
     * @memberof CallForwardingBusy
     */
    fwdToType?: CallForwardingBusyFwdToTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingBusy
     */
    fwdToTypeDataCall?: CallForwardingBusyFwdToTypeDataCallEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingBusy
     */
    inherit?: CallForwardingBusyInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingBusy
     */
    restrictIdBackward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingBusy
     */
    restrictIdForward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingBusy
     */
    specialDialTone?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallForwardingBusy
     */
    status?: CallForwardingBusyStatusEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingBusy
     */
    tas181Mode?: CallForwardingBusyTas181ModeEnum;
}

export const CallForwardingBusyFwdToTypeEnum = {
    Dn: "TO_DN",
    Vms: "TO_VMS",
    Attnd: "TO_ATTND",
} as const;

export type CallForwardingBusyFwdToTypeEnum = (typeof CallForwardingBusyFwdToTypeEnum)[keyof typeof CallForwardingBusyFwdToTypeEnum];
export const CallForwardingBusyFwdToTypeDataCallEnum = {
    UseVoice: "USE_VOICE",
    ToDn: "TO_DN",
    ToVms: "TO_VMS",
    ToAttnd: "TO_ATTND",
} as const;

export type CallForwardingBusyFwdToTypeDataCallEnum = (typeof CallForwardingBusyFwdToTypeDataCallEnum)[keyof typeof CallForwardingBusyFwdToTypeDataCallEnum];
export const CallForwardingBusyInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallForwardingBusyInheritEnum = (typeof CallForwardingBusyInheritEnum)[keyof typeof CallForwardingBusyInheritEnum];
export const CallForwardingBusyStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type CallForwardingBusyStatusEnum = (typeof CallForwardingBusyStatusEnum)[keyof typeof CallForwardingBusyStatusEnum];
export const CallForwardingBusyTas181ModeEnum = {
    None: "TAS_181_NONE",
    NoFwinfo: "TAS_181_NO_FWINFO",
    WithFwinfo: "TAS_181_WITH_FWINFO",
} as const;

export type CallForwardingBusyTas181ModeEnum = (typeof CallForwardingBusyTas181ModeEnum)[keyof typeof CallForwardingBusyTas181ModeEnum];

/**
 *
 * @export
 * @interface CallForwardingDefault
 */
export interface CallForwardingDefault {
    /**
     *
     * @type {string}
     * @memberof CallForwardingDefault
     */
    busyActive?: CallForwardingDefaultBusyActiveEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingDefault
     */
    fwdDN?: string;
    /**
     *
     * @type {string}
     * @memberof CallForwardingDefault
     */
    fwdToType?: CallForwardingDefaultFwdToTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingDefault
     */
    inherit?: CallForwardingDefaultInheritEnum;
    /**
     *
     * @type {number}
     * @memberof CallForwardingDefault
     */
    naTimeout?: number;
    /**
     *
     * @type {string}
     * @memberof CallForwardingDefault
     */
    noanswerActive?: CallForwardingDefaultNoanswerActiveEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingDefault
     */
    restrictIdBackward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingDefault
     */
    restrictIdForward?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallForwardingDefault
     */
    tas181Mode?: CallForwardingDefaultTas181ModeEnum;
}

export const CallForwardingDefaultBusyActiveEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type CallForwardingDefaultBusyActiveEnum = (typeof CallForwardingDefaultBusyActiveEnum)[keyof typeof CallForwardingDefaultBusyActiveEnum];
export const CallForwardingDefaultFwdToTypeEnum = {
    Dn: "TO_DN",
    Vms: "TO_VMS",
    Attnd: "TO_ATTND",
} as const;

export type CallForwardingDefaultFwdToTypeEnum = (typeof CallForwardingDefaultFwdToTypeEnum)[keyof typeof CallForwardingDefaultFwdToTypeEnum];
export const CallForwardingDefaultInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallForwardingDefaultInheritEnum = (typeof CallForwardingDefaultInheritEnum)[keyof typeof CallForwardingDefaultInheritEnum];
export const CallForwardingDefaultNoanswerActiveEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type CallForwardingDefaultNoanswerActiveEnum = (typeof CallForwardingDefaultNoanswerActiveEnum)[keyof typeof CallForwardingDefaultNoanswerActiveEnum];
export const CallForwardingDefaultTas181ModeEnum = {
    None: "TAS_181_NONE",
    NoFwinfo: "TAS_181_NO_FWINFO",
    WithFwinfo: "TAS_181_WITH_FWINFO",
} as const;

export type CallForwardingDefaultTas181ModeEnum = (typeof CallForwardingDefaultTas181ModeEnum)[keyof typeof CallForwardingDefaultTas181ModeEnum];

/**
 *
 * @export
 * @interface CallForwardingNoAnswer
 */
export interface CallForwardingNoAnswer {
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingNoAnswer
     */
    forwardDataCalls?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingNoAnswer
     */
    forwardVoiceCalls?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNoAnswer
     */
    fwdDN?: string;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNoAnswer
     */
    fwdDNDataCall?: string;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNoAnswer
     */
    fwdToType?: CallForwardingNoAnswerFwdToTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNoAnswer
     */
    fwdToTypeDataCall?: CallForwardingNoAnswerFwdToTypeDataCallEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNoAnswer
     */
    inherit?: CallForwardingNoAnswerInheritEnum;
    /**
     *
     * @type {number}
     * @memberof CallForwardingNoAnswer
     */
    naTimeout?: number;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingNoAnswer
     */
    restrictIdBackward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingNoAnswer
     */
    restrictIdForward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingNoAnswer
     */
    specialDialTone?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNoAnswer
     */
    status?: CallForwardingNoAnswerStatusEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNoAnswer
     */
    tas181Mode?: CallForwardingNoAnswerTas181ModeEnum;
}

export const CallForwardingNoAnswerFwdToTypeEnum = {
    Dn: "TO_DN",
    Vms: "TO_VMS",
    Attnd: "TO_ATTND",
} as const;

export type CallForwardingNoAnswerFwdToTypeEnum = (typeof CallForwardingNoAnswerFwdToTypeEnum)[keyof typeof CallForwardingNoAnswerFwdToTypeEnum];
export const CallForwardingNoAnswerFwdToTypeDataCallEnum = {
    UseVoice: "USE_VOICE",
    ToDn: "TO_DN",
    ToVms: "TO_VMS",
    ToAttnd: "TO_ATTND",
} as const;

export type CallForwardingNoAnswerFwdToTypeDataCallEnum =
    (typeof CallForwardingNoAnswerFwdToTypeDataCallEnum)[keyof typeof CallForwardingNoAnswerFwdToTypeDataCallEnum];
export const CallForwardingNoAnswerInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallForwardingNoAnswerInheritEnum = (typeof CallForwardingNoAnswerInheritEnum)[keyof typeof CallForwardingNoAnswerInheritEnum];
export const CallForwardingNoAnswerStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type CallForwardingNoAnswerStatusEnum = (typeof CallForwardingNoAnswerStatusEnum)[keyof typeof CallForwardingNoAnswerStatusEnum];
export const CallForwardingNoAnswerTas181ModeEnum = {
    None: "TAS_181_NONE",
    NoFwinfo: "TAS_181_NO_FWINFO",
    WithFwinfo: "TAS_181_WITH_FWINFO",
} as const;

export type CallForwardingNoAnswerTas181ModeEnum = (typeof CallForwardingNoAnswerTas181ModeEnum)[keyof typeof CallForwardingNoAnswerTas181ModeEnum];

/**
 *
 * @export
 * @interface CallForwardingNotReachable
 */
export interface CallForwardingNotReachable {
    /**
     *
     * @type {string}
     * @memberof CallForwardingNotReachable
     */
    fwdDN?: string;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNotReachable
     */
    fwdToType?: CallForwardingNotReachableFwdToTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNotReachable
     */
    inherit?: CallForwardingNotReachableInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingNotReachable
     */
    restrictIdBackward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingNotReachable
     */
    restrictIdForward?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNotReachable
     */
    status?: CallForwardingNotReachableStatusEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNotReachable
     */
    tas181Mode?: CallForwardingNotReachableTas181ModeEnum;
}

export const CallForwardingNotReachableFwdToTypeEnum = {
    Dn: "TO_DN",
    Vms: "TO_VMS",
    Attnd: "TO_ATTND",
} as const;

export type CallForwardingNotReachableFwdToTypeEnum = (typeof CallForwardingNotReachableFwdToTypeEnum)[keyof typeof CallForwardingNotReachableFwdToTypeEnum];
export const CallForwardingNotReachableInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallForwardingNotReachableInheritEnum = (typeof CallForwardingNotReachableInheritEnum)[keyof typeof CallForwardingNotReachableInheritEnum];
export const CallForwardingNotReachableStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type CallForwardingNotReachableStatusEnum = (typeof CallForwardingNotReachableStatusEnum)[keyof typeof CallForwardingNotReachableStatusEnum];
export const CallForwardingNotReachableTas181ModeEnum = {
    None: "TAS_181_NONE",
    NoFwinfo: "TAS_181_NO_FWINFO",
    WithFwinfo: "TAS_181_WITH_FWINFO",
} as const;

export type CallForwardingNotReachableTas181ModeEnum = (typeof CallForwardingNotReachableTas181ModeEnum)[keyof typeof CallForwardingNotReachableTas181ModeEnum];

/**
 *
 * @export
 * @interface CallForwardingUnregistered
 */
export interface CallForwardingUnregistered {
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingUnregistered
     */
    forwardDataCalls?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingUnregistered
     */
    forwardVoiceCalls?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallForwardingUnregistered
     */
    fwdDN?: string;
    /**
     *
     * @type {string}
     * @memberof CallForwardingUnregistered
     */
    fwdDNDataCall?: string;
    /**
     *
     * @type {string}
     * @memberof CallForwardingUnregistered
     */
    fwdToType?: CallForwardingUnregisteredFwdToTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingUnregistered
     */
    fwdToTypeDataCall?: CallForwardingUnregisteredFwdToTypeDataCallEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingUnregistered
     */
    inherit?: CallForwardingUnregisteredInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingUnregistered
     */
    restrictIdBackward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingUnregistered
     */
    restrictIdForward?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallForwardingUnregistered
     */
    status?: CallForwardingUnregisteredStatusEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingUnregistered
     */
    tas181Mode?: CallForwardingUnregisteredTas181ModeEnum;
}

export const CallForwardingUnregisteredFwdToTypeEnum = {
    Dn: "TO_DN",
    Vms: "TO_VMS",
    Attnd: "TO_ATTND",
} as const;

export type CallForwardingUnregisteredFwdToTypeEnum = (typeof CallForwardingUnregisteredFwdToTypeEnum)[keyof typeof CallForwardingUnregisteredFwdToTypeEnum];
export const CallForwardingUnregisteredFwdToTypeDataCallEnum = {
    UseVoice: "USE_VOICE",
    ToDn: "TO_DN",
    ToVms: "TO_VMS",
    ToAttnd: "TO_ATTND",
} as const;

export type CallForwardingUnregisteredFwdToTypeDataCallEnum =
    (typeof CallForwardingUnregisteredFwdToTypeDataCallEnum)[keyof typeof CallForwardingUnregisteredFwdToTypeDataCallEnum];
export const CallForwardingUnregisteredInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallForwardingUnregisteredInheritEnum = (typeof CallForwardingUnregisteredInheritEnum)[keyof typeof CallForwardingUnregisteredInheritEnum];
export const CallForwardingUnregisteredStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type CallForwardingUnregisteredStatusEnum = (typeof CallForwardingUnregisteredStatusEnum)[keyof typeof CallForwardingUnregisteredStatusEnum];
export const CallForwardingUnregisteredTas181ModeEnum = {
    None: "TAS_181_NONE",
    NoFwinfo: "TAS_181_NO_FWINFO",
    WithFwinfo: "TAS_181_WITH_FWINFO",
} as const;

export type CallForwardingUnregisteredTas181ModeEnum = (typeof CallForwardingUnregisteredTas181ModeEnum)[keyof typeof CallForwardingUnregisteredTas181ModeEnum];

/**
 *
 * @export
 * @interface CallForwardingVariable
 */
export interface CallForwardingVariable {
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingVariable
     */
    forwardDataCalls?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingVariable
     */
    forwardVoiceCalls?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallForwardingVariable
     */
    fwdDN?: string;
    /**
     *
     * @type {string}
     * @memberof CallForwardingVariable
     */
    fwdDNDataCall?: string;
    /**
     *
     * @type {string}
     * @memberof CallForwardingVariable
     */
    fwdToType?: CallForwardingVariableFwdToTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingVariable
     */
    fwdToTypeDataCall?: CallForwardingVariableFwdToTypeDataCallEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingVariable
     */
    inherit?: CallForwardingVariableInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingVariable
     */
    pingRing?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingVariable
     */
    restrictIdBackward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingVariable
     */
    restrictIdForward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingVariable
     */
    specialDialTone?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallForwardingVariable
     */
    status?: CallForwardingVariableStatusEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingVariable
     */
    tas181Mode?: CallForwardingVariableTas181ModeEnum;
}

export const CallForwardingVariableFwdToTypeEnum = {
    Dn: "TO_DN",
    Vms: "TO_VMS",
    Attnd: "TO_ATTND",
} as const;

export type CallForwardingVariableFwdToTypeEnum = (typeof CallForwardingVariableFwdToTypeEnum)[keyof typeof CallForwardingVariableFwdToTypeEnum];
export const CallForwardingVariableFwdToTypeDataCallEnum = {
    UseVoice: "USE_VOICE",
    ToDn: "TO_DN",
    ToVms: "TO_VMS",
    ToAttnd: "TO_ATTND",
} as const;

export type CallForwardingVariableFwdToTypeDataCallEnum =
    (typeof CallForwardingVariableFwdToTypeDataCallEnum)[keyof typeof CallForwardingVariableFwdToTypeDataCallEnum];
export const CallForwardingVariableInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallForwardingVariableInheritEnum = (typeof CallForwardingVariableInheritEnum)[keyof typeof CallForwardingVariableInheritEnum];
export const CallForwardingVariableStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type CallForwardingVariableStatusEnum = (typeof CallForwardingVariableStatusEnum)[keyof typeof CallForwardingVariableStatusEnum];
export const CallForwardingVariableTas181ModeEnum = {
    None: "TAS_181_NONE",
    NoFwinfo: "TAS_181_NO_FWINFO",
    WithFwinfo: "TAS_181_WITH_FWINFO",
} as const;

export type CallForwardingVariableTas181ModeEnum = (typeof CallForwardingVariableTas181ModeEnum)[keyof typeof CallForwardingVariableTas181ModeEnum];

/**
 *
 * @export
 * @interface CallWaiting
 */
export interface CallWaiting {
    /**
     *
     * @type {string}
     * @memberof CallWaiting
     */
    inherit?: CallWaitingInheritEnum;
    /**
     *
     * @type {string}
     * @memberof CallWaiting
     */
    status?: CallWaitingStatusEnum;
}

export const CallWaitingInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallWaitingInheritEnum = (typeof CallWaitingInheritEnum)[keyof typeof CallWaitingInheritEnum];
export const CallWaitingStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type CallWaitingStatusEnum = (typeof CallWaitingStatusEnum)[keyof typeof CallWaitingStatusEnum];

/**
 *
 * @export
 * @interface CallingLineId
 */
export interface CallingLineId {
    /**
     *
     * @type {string}
     * @memberof CallingLineId
     */
    clirUntilTime?: string;
    /**
     *
     * @type {boolean}
     * @memberof CallingLineId
     */
    connectedLinePresentation?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallingLineId
     */
    connectedLineRestriction?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallingLineId
     */
    inherit?: CallingLineIdInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallingLineId
     */
    lineIdPresentation?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallingLineId
     */
    namePresentation?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallingLineId
     */
    restrictionType?: CallingLineIdRestrictionTypeEnum;
}

export const CallingLineIdInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallingLineIdInheritEnum = (typeof CallingLineIdInheritEnum)[keyof typeof CallingLineIdInheritEnum];
export const CallingLineIdRestrictionTypeEnum = {
    Public: "PUBLIC",
    Private: "PRIVATE",
    PermPublic: "PERM_PUBLIC",
    PermPrivate: "PERM_PRIVATE",
} as const;

export type CallingLineIdRestrictionTypeEnum = (typeof CallingLineIdRestrictionTypeEnum)[keyof typeof CallingLineIdRestrictionTypeEnum];

/**
 *
 * @export
 * @interface CommunicationSettings
 */
export interface CommunicationSettings {
    /**
     *
     * @type {AnonymousCallRejection}
     * @memberof CommunicationSettings
     */
    anonymousCallRejection?: AnonymousCallRejection;
    /**
     *
     * @type {AutoAttendant}
     * @memberof CommunicationSettings
     */
    autoAttendant?: AutoAttendant;
    /**
     *
     * @type {BlockCallCompletionBusySubscriber}
     * @memberof CommunicationSettings
     */
    blockCallCompletionBusySubscriber?: BlockCallCompletionBusySubscriber;
    /**
     *
     * @type {BusyLampField}
     * @memberof CommunicationSettings
     */
    busyLampField?: BusyLampField;
    /**
     *
     * @type {CallBarring}
     * @memberof CommunicationSettings
     */
    callBarring?: CallBarring;
    /**
     *
     * @type {CallBlocking}
     * @memberof CommunicationSettings
     */
    callBlocking?: CallBlocking;
    /**
     *
     * @type {CallDeflection}
     * @memberof CommunicationSettings
     */
    callDeflection?: CallDeflection;
    /**
     *
     * @type {CallForwardingBusy}
     * @memberof CommunicationSettings
     */
    callForwardingBusy?: CallForwardingBusy;
    /**
     *
     * @type {CallForwardingDefault}
     * @memberof CommunicationSettings
     */
    callForwardingDefault?: CallForwardingDefault;
    /**
     *
     * @type {CallForwardingNoAnswer}
     * @memberof CommunicationSettings
     */
    callForwardingNoAnswer?: CallForwardingNoAnswer;
    /**
     *
     * @type {CallForwardingNotReachable}
     * @memberof CommunicationSettings
     */
    callForwardingNotReachable?: CallForwardingNotReachable;
    /**
     *
     * @type {CallForwardingUnregistered}
     * @memberof CommunicationSettings
     */
    callForwardingUnregistered?: CallForwardingUnregistered;
    /**
     *
     * @type {CallForwardingVariable}
     * @memberof CommunicationSettings
     */
    callForwardingVariable?: CallForwardingVariable;
    /**
     *
     * @type {CallWaiting}
     * @memberof CommunicationSettings
     */
    callWaiting?: CallWaiting;
    /**
     *
     * @type {CallingLineId}
     * @memberof CommunicationSettings
     */
    callingLineId?: CallingLineId;
    /**
     *
     * @type {DNExtension}
     * @memberof CommunicationSettings
     */
    dnExtension?: DNExtension;
    /**
     *
     * @type {DoNotDisturb}
     * @memberof CommunicationSettings
     */
    doNotDisturb?: DoNotDisturb;
    /**
     *
     * @type {FlexibleCallingLineId}
     * @memberof CommunicationSettings
     */
    flexibleCallingLineID?: FlexibleCallingLineId;
    /**
     *
     * @type {HotlineWarmline}
     * @memberof CommunicationSettings
     */
    hotlineWarmline?: HotlineWarmline;
    /**
     *
     * @type {InhibitIncomingForwarded}
     * @memberof CommunicationSettings
     */
    inhibitIncomingForwarded?: InhibitIncomingForwarded;
    /**
     *
     * @type {LanguageSelection}
     * @memberof CommunicationSettings
     */
    languageSelection?: LanguageSelection;
    /**
     *
     * @type {MiRingBack}
     * @memberof CommunicationSettings
     */
    miRingback?: MiRingBack;
    /**
     *
     * @type {MultipleRingPattern}
     * @memberof CommunicationSettings
     */
    multipleRingPattern?: MultipleRingPattern;
    /**
     *
     * @type {MusicOnHold}
     * @memberof CommunicationSettings
     */
    musicOnHold?: MusicOnHold;
    /**
     *
     * @type {OutgoingCallBarring}
     * @memberof CommunicationSettings
     */
    outgoingCallBarring?: OutgoingCallBarring;
    /**
     *
     * @type {PersonalizedRingbackTone}
     * @memberof CommunicationSettings
     */
    personalizedRingbackTone?: PersonalizedRingbackTone;
    /**
     *
     * @type {PinService}
     * @memberof CommunicationSettings
     */
    pinService?: PinService;
    /**
     *
     * @type {SelectiveCallAcceptance}
     * @memberof CommunicationSettings
     */
    selectiveCallAcceptance?: SelectiveCallAcceptance;
    /**
     *
     * @type {SelectiveCallForwarding}
     * @memberof CommunicationSettings
     */
    selectiveCallForwarding?: SelectiveCallForwarding;
    /**
     *
     * @type {SelectiveCallRejection}
     * @memberof CommunicationSettings
     */
    selectiveCallRejection?: SelectiveCallRejection;
    /**
     *
     * @type {SelectiveDistinctiveAlerting}
     * @memberof CommunicationSettings
     */
    selectiveDistinctiveAlerting?: SelectiveDistinctiveAlerting;
    /**
     *
     * @type {SequentialRing}
     * @memberof CommunicationSettings
     */
    sequentialRing?: SequentialRing;
    /**
     *
     * @type {SimultaneousRing}
     * @memberof CommunicationSettings
     */
    simultaneousRing?: SimultaneousRing;
    /**
     *
     * @type {SpeedDial100}
     * @memberof CommunicationSettings
     */
    speedDial100?: SpeedDial100;
    /**
     *
     * @type {SpeedDial8}
     * @memberof CommunicationSettings
     */
    speedDial8?: SpeedDial8;
    /**
     *
     * @type {TimeZone}
     * @memberof CommunicationSettings
     */
    timeZone?: TimeZone;
    /**
     *
     * @type {Vdd}
     * @memberof CommunicationSettings
     */
    vdd?: Vdd;
}

/**
 *
 * @export
 * @interface DNExtension
 */
export interface DNExtension {
    /**
     *
     * @type {Array<ExtensionEntry>}
     * @memberof DNExtension
     */
    dnExtLists?: Array<ExtensionEntry>;
    /**
     *
     * @type {boolean}
     * @memberof DNExtension
     */
    vmflag?: boolean;
}

/**
 *
 * @export
 * @interface DoNotDisturb
 */
export interface DoNotDisturb {
    /**
     *
     * @type {string}
     * @memberof DoNotDisturb
     */
    callHandling?: DoNotDisturbCallHandlingEnum;
    /**
     *
     * @type {string}
     * @memberof DoNotDisturb
     */
    inherit?: DoNotDisturbInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof DoNotDisturb
     */
    pingRing?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof DoNotDisturb
     */
    playAnnouncement?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof DoNotDisturb
     */
    specialDialTone?: boolean;
    /**
     *
     * @type {string}
     * @memberof DoNotDisturb
     */
    status?: DoNotDisturbStatusEnum;
}

export const DoNotDisturbCallHandlingEnum = {
    Busy: "DND_BUSY",
    FwdVm: "DND_FWD_VM",
} as const;

export type DoNotDisturbCallHandlingEnum = (typeof DoNotDisturbCallHandlingEnum)[keyof typeof DoNotDisturbCallHandlingEnum];
export const DoNotDisturbInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type DoNotDisturbInheritEnum = (typeof DoNotDisturbInheritEnum)[keyof typeof DoNotDisturbInheritEnum];
export const DoNotDisturbStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type DoNotDisturbStatusEnum = (typeof DoNotDisturbStatusEnum)[keyof typeof DoNotDisturbStatusEnum];

/**
 *
 * @export
 * @interface ErrorData
 */
export interface ErrorData {
    /**
     *
     * @type {Array<string>}
     * @memberof ErrorData
     */
    errorArgs?: Array<string>;
    /**
     *
     * @type {string}
     * @memberof ErrorData
     */
    errorDesc?: string;
    /**
     *
     * @type {string}
     * @memberof ErrorData
     */
    errorText?: string;
}

/**
 *
 * @export
 * @interface ExtensionEntry
 */
export interface ExtensionEntry {
    /**
     *
     * @type {boolean}
     * @memberof ExtensionEntry
     */
    alertExt?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof ExtensionEntry
     */
    ansConfirm?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof ExtensionEntry
     */
    bridgeAccess?: boolean;
    /**
     *
     * @type {string}
     * @memberof ExtensionEntry
     */
    extDN?: string;
    /**
     *
     * @type {string}
     * @memberof ExtensionEntry
     */
    extType?: ExtensionEntryExtTypeEnum;
    /**
     *
     * @type {boolean}
     * @memberof ExtensionEntry
     */
    pinRequired?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof ExtensionEntry
     */
    preservePAID?: boolean;
}

export const ExtensionEntryExtTypeEnum = {
    DeviceExt: "DEVICE_EXT",
    DnExt: "DN_EXT",
    DmhExt: "DMH_EXT",
} as const;

export type ExtensionEntryExtTypeEnum = (typeof ExtensionEntryExtTypeEnum)[keyof typeof ExtensionEntryExtTypeEnum];

/**
 *
 * @export
 * @interface FeatureList
 */
export interface FeatureList {
    /**
     *
     * @type {CommunicationSettings}
     * @memberof FeatureList
     */
    communicationSettings?: CommunicationSettings;
    /**
     *
     * @type {string}
     * @memberof FeatureList
     */
    puid?: string;
}

/**
 *
 * @export
 * @interface FlexibleCallingLineId
 */
export interface FlexibleCallingLineId {
    /**
     *
     * @type {string}
     * @memberof FlexibleCallingLineId
     */
    inherit?: FlexibleCallingLineIdInheritEnum;
    /**
     *
     * @type {string}
     * @memberof FlexibleCallingLineId
     */
    status?: FlexibleCallingLineIdStatusEnum;
}

export const FlexibleCallingLineIdInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type FlexibleCallingLineIdInheritEnum = (typeof FlexibleCallingLineIdInheritEnum)[keyof typeof FlexibleCallingLineIdInheritEnum];
export const FlexibleCallingLineIdStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type FlexibleCallingLineIdStatusEnum = (typeof FlexibleCallingLineIdStatusEnum)[keyof typeof FlexibleCallingLineIdStatusEnum];

/**
 *
 * @export
 * @interface HotlineWarmline
 */
export interface HotlineWarmline {
    /**
     *
     * @type {string}
     * @memberof HotlineWarmline
     */
    fwdDN?: string;
    /**
     *
     * @type {string}
     * @memberof HotlineWarmline
     */
    inherit?: HotlineWarmlineInheritEnum;
    /**
     *
     * @type {string}
     * @memberof HotlineWarmline
     */
    status?: HotlineWarmlineStatusEnum;
}

export const HotlineWarmlineInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type HotlineWarmlineInheritEnum = (typeof HotlineWarmlineInheritEnum)[keyof typeof HotlineWarmlineInheritEnum];
export const HotlineWarmlineStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type HotlineWarmlineStatusEnum = (typeof HotlineWarmlineStatusEnum)[keyof typeof HotlineWarmlineStatusEnum];

/**
 *
 * @export
 * @interface InhibitIncomingForwarded
 */
export interface InhibitIncomingForwarded {
    /**
     *
     * @type {string}
     * @memberof InhibitIncomingForwarded
     */
    inherit?: InhibitIncomingForwardedInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof InhibitIncomingForwarded
     */
    inhibitDataCall?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InhibitIncomingForwarded
     */
    inhibitVoiceCall?: boolean;
}

export const InhibitIncomingForwardedInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type InhibitIncomingForwardedInheritEnum = (typeof InhibitIncomingForwardedInheritEnum)[keyof typeof InhibitIncomingForwardedInheritEnum];

/**
 *
 * @export
 * @interface LanguageSelection
 */
export interface LanguageSelection {
    /**
     *
     * @type {string}
     * @memberof LanguageSelection
     */
    inherit?: LanguageSelectionInheritEnum;
    /**
     *
     * @type {string}
     * @memberof LanguageSelection
     */
    userSelectedLocale?: string;
}

export const LanguageSelectionInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type LanguageSelectionInheritEnum = (typeof LanguageSelectionInheritEnum)[keyof typeof LanguageSelectionInheritEnum];

/**
 *
 * @export
 * @interface MiRingBack
 */
export interface MiRingBack {
    /**
     *
     * @type {string}
     * @memberof MiRingBack
     */
    inherit?: MiRingBackInheritEnum;
    /**
     *
     * @type {string}
     * @memberof MiRingBack
     */
    status?: MiRingBackStatusEnum;
}

export const MiRingBackInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type MiRingBackInheritEnum = (typeof MiRingBackInheritEnum)[keyof typeof MiRingBackInheritEnum];
export const MiRingBackStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type MiRingBackStatusEnum = (typeof MiRingBackStatusEnum)[keyof typeof MiRingBackStatusEnum];

/**
 *
 * @export
 * @interface MultipleRingPattern
 */
export interface MultipleRingPattern {
    /**
     *
     * @type {string}
     * @memberof MultipleRingPattern
     */
    inherit?: MultipleRingPatternInheritEnum;
    /**
     *
     * @type {string}
     * @memberof MultipleRingPattern
     */
    ringPattern?: MultipleRingPatternRingPatternEnum;
}

export const MultipleRingPatternInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type MultipleRingPatternInheritEnum = (typeof MultipleRingPatternInheritEnum)[keyof typeof MultipleRingPatternInheritEnum];
export const MultipleRingPatternRingPatternEnum = {
    Standard: "STANDARD",
    Pattern1: "PATTERN_1",
    Pattern2: "PATTERN_2",
    Pattern3: "PATTERN_3",
    Pattern4: "PATTERN_4",
    Pattern5: "PATTERN_5",
    Pattern6: "PATTERN_6",
} as const;

export type MultipleRingPatternRingPatternEnum = (typeof MultipleRingPatternRingPatternEnum)[keyof typeof MultipleRingPatternRingPatternEnum];

/**
 *
 * @export
 * @interface MusicOnHold
 */
export interface MusicOnHold {
    /**
     *
     * @type {string}
     * @memberof MusicOnHold
     */
    inherit?: MusicOnHoldInheritEnum;
    /**
     *
     * @type {string}
     * @memberof MusicOnHold
     */
    status?: MusicOnHoldStatusEnum;
}

export const MusicOnHoldInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type MusicOnHoldInheritEnum = (typeof MusicOnHoldInheritEnum)[keyof typeof MusicOnHoldInheritEnum];
export const MusicOnHoldStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type MusicOnHoldStatusEnum = (typeof MusicOnHoldStatusEnum)[keyof typeof MusicOnHoldStatusEnum];

/**
 *
 * @export
 * @interface OneTime
 */
export interface OneTime {
    /**
     *
     * @type {string}
     * @memberof OneTime
     */
    endDate?: string;
    /**
     *
     * @type {boolean}
     * @memberof OneTime
     */
    overrideRecurringEntry?: boolean;
    /**
     *
     * @type {string}
     * @memberof OneTime
     */
    startDate?: string;
}

/**
 *
 * @export
 * @interface OutgoingCallBarring
 */
export interface OutgoingCallBarring {
    /**
     *
     * @type {string}
     * @memberof OutgoingCallBarring
     */
    inherit?: OutgoingCallBarringInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof OutgoingCallBarring
     */
    specialDialTone?: boolean;
    /**
     *
     * @type {string}
     * @memberof OutgoingCallBarring
     */
    status?: OutgoingCallBarringStatusEnum;
    /**
     *
     * @type {number}
     * @memberof OutgoingCallBarring
     */
    userProgramId?: number;
}

export const OutgoingCallBarringInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type OutgoingCallBarringInheritEnum = (typeof OutgoingCallBarringInheritEnum)[keyof typeof OutgoingCallBarringInheritEnum];
export const OutgoingCallBarringStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type OutgoingCallBarringStatusEnum = (typeof OutgoingCallBarringStatusEnum)[keyof typeof OutgoingCallBarringStatusEnum];

/**
 *
 * @export
 * @interface PersonalizedRingbackTone
 */
export interface PersonalizedRingbackTone {
    /**
     *
     * @type {string}
     * @memberof PersonalizedRingbackTone
     */
    inherit?: PersonalizedRingbackToneInheritEnum;
    /**
     *
     * @type {string}
     * @memberof PersonalizedRingbackTone
     */
    status?: PersonalizedRingbackToneStatusEnum;
}

export const PersonalizedRingbackToneInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type PersonalizedRingbackToneInheritEnum = (typeof PersonalizedRingbackToneInheritEnum)[keyof typeof PersonalizedRingbackToneInheritEnum];
export const PersonalizedRingbackToneStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type PersonalizedRingbackToneStatusEnum = (typeof PersonalizedRingbackToneStatusEnum)[keyof typeof PersonalizedRingbackToneStatusEnum];

/**
 *
 * @export
 * @interface PinService
 */
export interface PinService {
    /**
     *
     * @type {string}
     * @memberof PinService
     */
    inherit?: PinServiceInheritEnum;
    /**
     *
     * @type {string}
     * @memberof PinService
     */
    pinNum?: string;
}

export const PinServiceInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type PinServiceInheritEnum = (typeof PinServiceInheritEnum)[keyof typeof PinServiceInheritEnum];

/**
 *
 * @export
 * @interface PredefinedSettingsActivationLog
 */
export interface PredefinedSettingsActivationLog {
    /**
     *
     * @type {Array<PredefinedSettingsActivationLogItem>}
     * @memberof PredefinedSettingsActivationLog
     */
    settingsActivationLogs?: Array<PredefinedSettingsActivationLogItem>;
}

/**
 *
 * @export
 * @interface PredefinedSettingsActivationLogItem
 */
export interface PredefinedSettingsActivationLogItem {
    /**
     *
     * @type {ErrorData}
     * @memberof PredefinedSettingsActivationLogItem
     */
    errorData?: ErrorData;
    /**
     *
     * @type {boolean}
     * @memberof PredefinedSettingsActivationLogItem
     */
    scheduledActivation?: boolean;
    /**
     *
     * @type {string}
     * @memberof PredefinedSettingsActivationLogItem
     */
    settingsId?: string;
    /**
     *
     * @type {string}
     * @memberof PredefinedSettingsActivationLogItem
     */
    timeStarted?: string;
    /**
     *
     * @type {boolean}
     * @memberof PredefinedSettingsActivationLogItem
     */
    wasSuccessful?: boolean;
}

/**
 *
 * @export
 * @interface PredefinedSettingsIdList
 */
export interface PredefinedSettingsIdList {
    /**
     *
     * @type {Array<ProfileData>}
     * @memberof PredefinedSettingsIdList
     */
    profile?: Array<ProfileData>;
}

/**
 *
 * @export
 * @interface PredefinedSettingsProfile
 */
export interface PredefinedSettingsProfile {
    /**
     *
     * @type {ProfileFeatureList}
     * @memberof PredefinedSettingsProfile
     */
    profileFeatureList?: ProfileFeatureList;
    /**
     *
     * @type {string}
     * @memberof PredefinedSettingsProfile
     */
    profileName?: string;
}

/**
 *
 * @export
 * @interface PredefinedSettingsSchedule
 */
export interface PredefinedSettingsSchedule {
    /**
     *
     * @type {string}
     * @memberof PredefinedSettingsSchedule
     */
    defaultProfileId?: string;
    /**
     *
     * @type {boolean}
     * @memberof PredefinedSettingsSchedule
     */
    isActive?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PredefinedSettingsSchedule
     */
    removeExpiredEntries?: boolean;
    /**
     *
     * @type {Array<SettingsSchedule>}
     * @memberof PredefinedSettingsSchedule
     */
    settingsScheduleEntry?: Array<SettingsSchedule>;
}

/**
 *
 * @export
 * @interface ProfileData
 */
export interface ProfileData {
    /**
     *
     * @type {boolean}
     * @memberof ProfileData
     */
    isActive?: boolean;
    /**
     *
     * @type {string}
     * @memberof ProfileData
     */
    profileId?: string;
    /**
     *
     * @type {string}
     * @memberof ProfileData
     */
    profileName?: string;
}

/**
 *
 * @export
 * @interface ProfileFeatureList
 */
export interface ProfileFeatureList {
    /**
     *
     * @type {Array<FeatureList>}
     * @memberof ProfileFeatureList
     */
    featureList?: Array<FeatureList>;
}

/**
 *
 * @export
 * @interface Recurrence
 */
export interface Recurrence {
    /**
     *
     * @type {Array<string>}
     * @memberof Recurrence
     */
    dayList?: Array<RecurrenceDayListsEnum>;
    /**
     *
     * @type {string}
     * @memberof Recurrence
     */
    daySelection?: RecurrenceDaySelectionEnum;
    /**
     *
     * @type {TimeOfDay}
     * @memberof Recurrence
     */
    endTime?: TimeOfDay;
    /**
     *
     * @type {TimeOfDay}
     * @memberof Recurrence
     */
    startTime?: TimeOfDay;
}

export const RecurrenceDayListsEnum = {
    Sunday: "SUNDAY",
    Monday: "MONDAY",
    Tuesday: "TUESDAY",
    Wednesday: "WEDNESDAY",
    Thursday: "THURSDAY",
    Friday: "FRIDAY",
    Saturday: "SATURDAY",
} as const;

export type RecurrenceDayListsEnum = (typeof RecurrenceDayListsEnum)[keyof typeof RecurrenceDayListsEnum];
export const RecurrenceDaySelectionEnum = {
    Daily: "DAILY",
    Weekend: "WEEKEND",
    Weekday: "WEEKDAY",
    SpecificDays: "SPECIFIC_DAYS",
} as const;

export type RecurrenceDaySelectionEnum = (typeof RecurrenceDaySelectionEnum)[keyof typeof RecurrenceDaySelectionEnum];

/**
 * The Nokia TAS API may add a service exception into the response body to provide more information in case of an unsuccessful API call. This is done by including a RequestError element into the response body.  **serviceException**: Faults related to the operation of the service, result in the return of a ServiceException message.
 * @export
 * @interface RequestError
 */
export interface RequestError {
    /**
     *
     * @type {ServiceException}
     * @memberof RequestError
     */
    serviceException: ServiceException;
}

/**
 *
 * @export
 * @interface SEQRNGEntry
 */
export interface SEQRNGEntry {
    /**
     *
     * @type {boolean}
     * @memberof SEQRNGEntry
     */
    ansConfirm?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof SEQRNGEntry
     */
    continueOnBusy?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof SEQRNGEntry
     */
    continueOnNoAnswer?: boolean;
    /**
     *
     * @type {number}
     * @memberof SEQRNGEntry
     */
    naTimeout?: number;
    /**
     *
     * @type {string}
     * @memberof SEQRNGEntry
     */
    ringPattern?: SEQRNGEntryRingPatternEnum;
    /**
     *
     * @type {string}
     * @memberof SEQRNGEntry
     */
    seqDN?: string;
}

export const SEQRNGEntryRingPatternEnum = {
    Standard: "STANDARD",
    Pattern1: "PATTERN_1",
    Pattern2: "PATTERN_2",
    Pattern3: "PATTERN_3",
    Pattern4: "PATTERN_4",
    Pattern5: "PATTERN_5",
    Pattern6: "PATTERN_6",
} as const;

export type SEQRNGEntryRingPatternEnum = (typeof SEQRNGEntryRingPatternEnum)[keyof typeof SEQRNGEntryRingPatternEnum];

/**
 *
 * @export
 * @interface SIMRNGEntry
 */
export interface SIMRNGEntry {
    /**
     *
     * @type {boolean}
     * @memberof SIMRNGEntry
     */
    ansConfirm?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof SIMRNGEntry
     */
    family?: boolean;
    /**
     *
     * @type {string}
     * @memberof SIMRNGEntry
     */
    ringPattern?: SIMRNGEntryRingPatternEnum;
    /**
     *
     * @type {string}
     * @memberof SIMRNGEntry
     */
    simDN?: string;
}

export const SIMRNGEntryRingPatternEnum = {
    Standard: "STANDARD",
    Pattern1: "PATTERN_1",
    Pattern2: "PATTERN_2",
    Pattern3: "PATTERN_3",
    Pattern4: "PATTERN_4",
    Pattern5: "PATTERN_5",
    Pattern6: "PATTERN_6",
} as const;

export type SIMRNGEntryRingPatternEnum = (typeof SIMRNGEntryRingPatternEnum)[keyof typeof SIMRNGEntryRingPatternEnum];

/**
 *
 * @export
 * @interface SdaEntry
 */
export interface SdaEntry {
    /**
     *
     * @type {string}
     * @memberof SdaEntry
     */
    ringPattern?: SdaEntryRingPatternEnum;
    /**
     *
     * @type {string}
     * @memberof SdaEntry
     */
    sdaDN?: string;
}

export const SdaEntryRingPatternEnum = {
    Standard: "STANDARD",
    Pattern1: "PATTERN_1",
    Pattern2: "PATTERN_2",
    Pattern3: "PATTERN_3",
    Pattern4: "PATTERN_4",
    Pattern5: "PATTERN_5",
    Pattern6: "PATTERN_6",
} as const;

export type SdaEntryRingPatternEnum = (typeof SdaEntryRingPatternEnum)[keyof typeof SdaEntryRingPatternEnum];

/**
 *
 * @export
 * @interface SelRejectEntry
 */
export interface SelRejectEntry {
    /**
     *
     * @type {string}
     * @memberof SelRejectEntry
     */
    selectiveDN?: string;
    /**
     *
     * @type {number}
     * @memberof SelRejectEntry
     */
    timestamp?: number;
    /**
     *
     * @type {string}
     * @memberof SelRejectEntry
     */
    token?: string;
}

/**
 *
 * @export
 * @interface SelectiveCallAcceptance
 */
export interface SelectiveCallAcceptance {
    /**
     *
     * @type {string}
     * @memberof SelectiveCallAcceptance
     */
    fwdDN?: string;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallAcceptance
     */
    fwdToType?: SelectiveCallAcceptanceFwdToTypeEnum;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallAcceptance
     */
    inherit?: SelectiveCallAcceptanceInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof SelectiveCallAcceptance
     */
    restrictIdBackward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof SelectiveCallAcceptance
     */
    restrictIdForward?: boolean;
    /**
     *
     * @type {Array<SelectiveDNEntry>}
     * @memberof SelectiveCallAcceptance
     */
    scaList?: Array<SelectiveDNEntry>;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallAcceptance
     */
    status?: SelectiveCallAcceptanceStatusEnum;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallAcceptance
     */
    tas181Mode?: SelectiveCallAcceptanceTas181ModeEnum;
    /**
     *
     * @type {boolean}
     * @memberof SelectiveCallAcceptance
     */
    useForwarded?: boolean;
}

export const SelectiveCallAcceptanceFwdToTypeEnum = {
    Dn: "TO_DN",
    Vms: "TO_VMS",
    Attnd: "TO_ATTND",
} as const;

export type SelectiveCallAcceptanceFwdToTypeEnum = (typeof SelectiveCallAcceptanceFwdToTypeEnum)[keyof typeof SelectiveCallAcceptanceFwdToTypeEnum];
export const SelectiveCallAcceptanceInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type SelectiveCallAcceptanceInheritEnum = (typeof SelectiveCallAcceptanceInheritEnum)[keyof typeof SelectiveCallAcceptanceInheritEnum];
export const SelectiveCallAcceptanceStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type SelectiveCallAcceptanceStatusEnum = (typeof SelectiveCallAcceptanceStatusEnum)[keyof typeof SelectiveCallAcceptanceStatusEnum];
export const SelectiveCallAcceptanceTas181ModeEnum = {
    None: "TAS_181_NONE",
    NoFwinfo: "TAS_181_NO_FWINFO",
    WithFwinfo: "TAS_181_WITH_FWINFO",
} as const;

export type SelectiveCallAcceptanceTas181ModeEnum = (typeof SelectiveCallAcceptanceTas181ModeEnum)[keyof typeof SelectiveCallAcceptanceTas181ModeEnum];

/**
 *
 * @export
 * @interface SelectiveCallForwarding
 */
export interface SelectiveCallForwarding {
    /**
     *
     * @type {string}
     * @memberof SelectiveCallForwarding
     */
    fwdDN?: string;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallForwarding
     */
    fwdToType?: SelectiveCallForwardingFwdToTypeEnum;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallForwarding
     */
    inherit?: SelectiveCallForwardingInheritEnum;
    /**
     *
     * @type {number}
     * @memberof SelectiveCallForwarding
     */
    naTimeout?: number;
    /**
     *
     * @type {boolean}
     * @memberof SelectiveCallForwarding
     */
    pingRing?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof SelectiveCallForwarding
     */
    restrictIdBackward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof SelectiveCallForwarding
     */
    restrictIdForward?: boolean;
    /**
     *
     * @type {Array<SelectiveDNEntry>}
     * @memberof SelectiveCallForwarding
     */
    scfList?: Array<SelectiveDNEntry>;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallForwarding
     */
    scfType?: SelectiveCallForwardingScfTypeEnum;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallForwarding
     */
    status?: SelectiveCallForwardingStatusEnum;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallForwarding
     */
    tas181Mode?: SelectiveCallForwardingTas181ModeEnum;
}

export const SelectiveCallForwardingFwdToTypeEnum = {
    Dn: "TO_DN",
    Vms: "TO_VMS",
    Attnd: "TO_ATTND",
} as const;

export type SelectiveCallForwardingFwdToTypeEnum = (typeof SelectiveCallForwardingFwdToTypeEnum)[keyof typeof SelectiveCallForwardingFwdToTypeEnum];
export const SelectiveCallForwardingInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type SelectiveCallForwardingInheritEnum = (typeof SelectiveCallForwardingInheritEnum)[keyof typeof SelectiveCallForwardingInheritEnum];
export const SelectiveCallForwardingScfTypeEnum = {
    Unconditional: "UNCONDITIONAL",
    Busy: "BUSY",
    Noresponse: "NORESPONSE",
    Unreachable: "UNREACHABLE",
} as const;

export type SelectiveCallForwardingScfTypeEnum = (typeof SelectiveCallForwardingScfTypeEnum)[keyof typeof SelectiveCallForwardingScfTypeEnum];
export const SelectiveCallForwardingStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type SelectiveCallForwardingStatusEnum = (typeof SelectiveCallForwardingStatusEnum)[keyof typeof SelectiveCallForwardingStatusEnum];
export const SelectiveCallForwardingTas181ModeEnum = {
    None: "TAS_181_NONE",
    NoFwinfo: "TAS_181_NO_FWINFO",
    WithFwinfo: "TAS_181_WITH_FWINFO",
} as const;

export type SelectiveCallForwardingTas181ModeEnum = (typeof SelectiveCallForwardingTas181ModeEnum)[keyof typeof SelectiveCallForwardingTas181ModeEnum];

/**
 *
 * @export
 * @interface SelectiveCallRejection
 */
export interface SelectiveCallRejection {
    /**
     *
     * @type {string}
     * @memberof SelectiveCallRejection
     */
    inherit?: SelectiveCallRejectionInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof SelectiveCallRejection
     */
    pingRing?: boolean;
    /**
     *
     * @type {Array<SelRejectEntry>}
     * @memberof SelectiveCallRejection
     */
    selRejectList?: Array<SelRejectEntry>;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallRejection
     */
    status?: SelectiveCallRejectionStatusEnum;
}

export const SelectiveCallRejectionInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type SelectiveCallRejectionInheritEnum = (typeof SelectiveCallRejectionInheritEnum)[keyof typeof SelectiveCallRejectionInheritEnum];
export const SelectiveCallRejectionStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type SelectiveCallRejectionStatusEnum = (typeof SelectiveCallRejectionStatusEnum)[keyof typeof SelectiveCallRejectionStatusEnum];

/**
 *
 * @export
 * @interface SelectiveDNEntry
 */
export interface SelectiveDNEntry {
    /**
     *
     * @type {string}
     * @memberof SelectiveDNEntry
     */
    selectiveDN?: string;
}

/**
 *
 * @export
 * @interface SelectiveDistinctiveAlerting
 */
export interface SelectiveDistinctiveAlerting {
    /**
     *
     * @type {string}
     * @memberof SelectiveDistinctiveAlerting
     */
    inherit?: SelectiveDistinctiveAlertingInheritEnum;
    /**
     *
     * @type {Array<SdaEntry>}
     * @memberof SelectiveDistinctiveAlerting
     */
    sdaLists?: Array<SdaEntry>;
    /**
     *
     * @type {string}
     * @memberof SelectiveDistinctiveAlerting
     */
    status?: SelectiveDistinctiveAlertingStatusEnum;
}

export const SelectiveDistinctiveAlertingInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type SelectiveDistinctiveAlertingInheritEnum = (typeof SelectiveDistinctiveAlertingInheritEnum)[keyof typeof SelectiveDistinctiveAlertingInheritEnum];
export const SelectiveDistinctiveAlertingStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type SelectiveDistinctiveAlertingStatusEnum = (typeof SelectiveDistinctiveAlertingStatusEnum)[keyof typeof SelectiveDistinctiveAlertingStatusEnum];

/**
 *
 * @export
 * @interface SequentialRing
 */
export interface SequentialRing {
    /**
     *
     * @type {boolean}
     * @memberof SequentialRing
     */
    continueOnBusy?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof SequentialRing
     */
    continueOnNoAnswer?: boolean;
    /**
     *
     * @type {number}
     * @memberof SequentialRing
     */
    defaultTimeout?: number;
    /**
     *
     * @type {string}
     * @memberof SequentialRing
     */
    inherit?: SequentialRingInheritEnum;
    /**
     *
     * @type {number}
     * @memberof SequentialRing
     */
    naTimeout?: number;
    /**
     *
     * @type {boolean}
     * @memberof SequentialRing
     */
    restrictIdBackward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof SequentialRing
     */
    restrictIdForward?: boolean;
    /**
     *
     * @type {Array<SEQRNGEntry>}
     * @memberof SequentialRing
     */
    seqrngList?: Array<SEQRNGEntry>;
    /**
     *
     * @type {string}
     * @memberof SequentialRing
     */
    status?: SequentialRingStatusEnum;
    /**
     *
     * @type {string}
     * @memberof SequentialRing
     */
    tas181Mode?: SequentialRingTas181ModeEnum;
}

export const SequentialRingInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type SequentialRingInheritEnum = (typeof SequentialRingInheritEnum)[keyof typeof SequentialRingInheritEnum];
export const SequentialRingStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type SequentialRingStatusEnum = (typeof SequentialRingStatusEnum)[keyof typeof SequentialRingStatusEnum];
export const SequentialRingTas181ModeEnum = {
    None: "TAS_181_NONE",
    NoFwinfo: "TAS_181_NO_FWINFO",
    WithFwinfo: "TAS_181_WITH_FWINFO",
} as const;

export type SequentialRingTas181ModeEnum = (typeof SequentialRingTas181ModeEnum)[keyof typeof SequentialRingTas181ModeEnum];

/**
 *
 * @export
 * @interface ServiceException
 */
export interface ServiceException {
    /**
     * Message identifier with a prefix SVC. The commonly used SVC are the following: SVC0002:Invalid input value; SVC0003:Invalid input value with list of valid values; SVC0004:No valid address(es); SVC0005:Duplicate correlator; SVC2000:Service error with description.
     * @type {string}
     * @memberof ServiceException
     */
    messageId: string;
    /**
     * Message text with replacement variables marked with %n, where n is an index in the list of <variables> elements, starting at 1.
     * @type {string}
     * @memberof ServiceException
     */
    text: string;
    /**
     *
     * @type {Array<string>}
     * @memberof ServiceException
     */
    variables?: Array<string>;
}

/**
 *
 * @export
 * @interface SettingsSchedule
 */
export interface SettingsSchedule {
    /**
     *
     * @type {OneTime}
     * @memberof SettingsSchedule
     */
    oneTime?: OneTime;
    /**
     *
     * @type {string}
     * @memberof SettingsSchedule
     */
    profileId?: string;
    /**
     *
     * @type {Recurrence}
     * @memberof SettingsSchedule
     */
    recurring?: Recurrence;
}

/**
 *
 * @export
 * @interface SettingsScheduleStatus
 */
export interface SettingsScheduleStatus {
    /**
     *
     * @type {boolean}
     * @memberof SettingsScheduleStatus
     */
    isActive?: boolean;
}

/**
 *
 * @export
 * @interface SimultaneousRing
 */
export interface SimultaneousRing {
    /**
     *
     * @type {string}
     * @memberof SimultaneousRing
     */
    inherit?: SimultaneousRingInheritEnum;
    /**
     *
     * @type {Array<SIMRNGEntry>}
     * @memberof SimultaneousRing
     */
    simrngList?: Array<SIMRNGEntry>;
    /**
     *
     * @type {string}
     * @memberof SimultaneousRing
     */
    status?: SimultaneousRingStatusEnum;
}

export const SimultaneousRingInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type SimultaneousRingInheritEnum = (typeof SimultaneousRingInheritEnum)[keyof typeof SimultaneousRingInheritEnum];
export const SimultaneousRingStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type SimultaneousRingStatusEnum = (typeof SimultaneousRingStatusEnum)[keyof typeof SimultaneousRingStatusEnum];

/**
 *
 * @export
 * @interface SpeedDial100
 */
export interface SpeedDial100 {
    /**
     *
     * @type {string}
     * @memberof SpeedDial100
     */
    inherit?: SpeedDial100InheritEnum;
    /**
     *
     * @type {Array<SpeedDial100Entry>}
     * @memberof SpeedDial100
     */
    spd100Lists?: Array<SpeedDial100Entry>;
}

export const SpeedDial100InheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type SpeedDial100InheritEnum = (typeof SpeedDial100InheritEnum)[keyof typeof SpeedDial100InheritEnum];

/**
 *
 * @export
 * @interface SpeedDial100Entry
 */
export interface SpeedDial100Entry {
    /**
     *
     * @type {string}
     * @memberof SpeedDial100Entry
     */
    code?: string;
    /**
     *
     * @type {string}
     * @memberof SpeedDial100Entry
     */
    number?: string;
}

/**
 *
 * @export
 * @interface SpeedDial8
 */
export interface SpeedDial8 {
    /**
     *
     * @type {string}
     * @memberof SpeedDial8
     */
    inherit?: SpeedDial8InheritEnum;
    /**
     *
     * @type {Array<SpeedDial8Entry>}
     * @memberof SpeedDial8
     */
    spd8Lists?: Array<SpeedDial8Entry>;
}

export const SpeedDial8InheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type SpeedDial8InheritEnum = (typeof SpeedDial8InheritEnum)[keyof typeof SpeedDial8InheritEnum];

/**
 *
 * @export
 * @interface SpeedDial8Entry
 */
export interface SpeedDial8Entry {
    /**
     *
     * @type {string}
     * @memberof SpeedDial8Entry
     */
    code?: string;
    /**
     *
     * @type {string}
     * @memberof SpeedDial8Entry
     */
    number?: string;
}

/**
 *
 * @export
 * @interface TimeOfDay
 */
export interface TimeOfDay {
    /**
     *
     * @type {number}
     * @memberof TimeOfDay
     */
    hour?: number;
    /**
     *
     * @type {number}
     * @memberof TimeOfDay
     */
    minute?: number;
}

/**
 *
 * @export
 * @interface TimeZone
 */
export interface TimeZone {
    /**
     *
     * @type {string}
     * @memberof TimeZone
     */
    inherit?: TimeZoneInheritEnum;
    /**
     *
     * @type {string}
     * @memberof TimeZone
     */
    userTimeZone?: string;
}

export const TimeZoneInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type TimeZoneInheritEnum = (typeof TimeZoneInheritEnum)[keyof typeof TimeZoneInheritEnum];

/**
 *
 * @export
 * @interface Vdd
 */
export interface Vdd {
    /**
     *
     * @type {string}
     * @memberof Vdd
     */
    inherit?: VddInheritEnum;
    /**
     *
     * @type {string}
     * @memberof Vdd
     */
    intraVpnRingPattern?: VddIntraVpnRingPatternEnum;
}

export const VddInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type VddInheritEnum = (typeof VddInheritEnum)[keyof typeof VddInheritEnum];
export const VddIntraVpnRingPatternEnum = {
    Standard: "STANDARD",
    Pattern1: "PATTERN_1",
    Pattern2: "PATTERN_2",
    Pattern3: "PATTERN_3",
    Pattern4: "PATTERN_4",
    Pattern5: "PATTERN_5",
    Pattern6: "PATTERN_6",
} as const;

export type VddIntraVpnRingPatternEnum = (typeof VddIntraVpnRingPatternEnum)[keyof typeof VddIntraVpnRingPatternEnum];

/**
 * CleanUserTodDataAPIApi - axios parameter creator
 * @export
 */
export const CleanUserTodDataAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary delete profile and schedule related data
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriber: async (puid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'puid' is not null or undefined
            assertParamExists("deleteSubscriber", "puid", puid);
            const localVarPath = `/v1/puid/{puid}`.replace(`{${"puid"}}`, encodeURIComponent(String(puid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "DELETE",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * CleanUserTodDataAPIApi - functional programming interface
 * @export
 */
export const CleanUserTodDataAPIApiFp = function (configuration?: Configuration) {
    const localVarAxiosParamCreator = CleanUserTodDataAPIApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete profile and schedule related data
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSubscriber(puid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSubscriber(puid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["CleanUserTodDataAPIApi.deleteSubscriber"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    };
};

/**
 * CleanUserTodDataAPIApi - factory interface
 * @export
 */
export const CleanUserTodDataAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CleanUserTodDataAPIApiFp(configuration);
    return {
        /**
         *
         * @summary delete profile and schedule related data
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriber(puid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteSubscriber(puid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CleanUserTodDataAPIApi - object-oriented interface
 * @export
 * @class CleanUserTodDataAPIApi
 * @extends {BaseAPI}
 */
export class CleanUserTodDataAPIApi extends BaseAPI {
    /**
     *
     * @summary delete profile and schedule related data
     * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CleanUserTodDataAPIApi
     */
    public deleteSubscriber(puid: string, options?: RawAxiosRequestConfig) {
        return CleanUserTodDataAPIApiFp(this.configuration)
            .deleteSubscriber(puid, options)
            .then((request) => request(this.axios, this.basePath));
    }
}

/**
 * ProfileManagementAPIApi - axios parameter creator
 * @export
 */
export const ProfileManagementAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Add a new profile
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {PredefinedSettingsProfile} predefinedSettingsProfile the detailed feature configuration in profile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProfileSettings: async (
            puid: string,
            predefinedSettingsProfile: PredefinedSettingsProfile,
            options: RawAxiosRequestConfig = {},
        ): Promise<RequestArgs> => {
            // verify required parameter 'puid' is not null or undefined
            assertParamExists("addProfileSettings", "puid", puid);
            // verify required parameter 'predefinedSettingsProfile' is not null or undefined
            assertParamExists("addProfileSettings", "predefinedSettingsProfile", predefinedSettingsProfile);
            const localVarPath = `/v1/profiles/puid/{puid}`.replace(`{${"puid"}}`, encodeURIComponent(String(puid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter["Content-Type"] = "application/json";

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(predefinedSettingsProfile, localVarRequestOptions, configuration);

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a profile
         * @param {string} profileId This parameter defines the ID of the profile, which is generated by server.
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfileSettings: async (profileId: string, puid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists("deleteProfileSettings", "profileId", profileId);
            // verify required parameter 'puid' is not null or undefined
            assertParamExists("deleteProfileSettings", "puid", puid);
            const localVarPath = `/v1/profiles/puid/{puid}/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"puid"}}`, encodeURIComponent(String(puid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "DELETE",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve the profile list
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileList: async (puid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'puid' is not null or undefined
            assertParamExists("getProfileList", "puid", puid);
            const localVarPath = `/v1/profiles/puid/{puid}`.replace(`{${"puid"}}`, encodeURIComponent(String(puid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a profile content
         * @param {string} profileId This parameter defines the ID of the profile, which is generated by the  server.
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileSettings: async (profileId: string, puid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists("getProfileSettings", "profileId", profileId);
            // verify required parameter 'puid' is not null or undefined
            assertParamExists("getProfileSettings", "puid", puid);
            const localVarPath = `/v1/profiles/puid/{puid}/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"puid"}}`, encodeURIComponent(String(puid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a profile content
         * @param {string} profileId This parameter defines the ID of the profile, which is generated by server.
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {PredefinedSettingsProfile} settingsProfile settingsProfile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfileSettings: async (
            profileId: string,
            puid: string,
            settingsProfile: PredefinedSettingsProfile,
            options: RawAxiosRequestConfig = {},
        ): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists("updateProfileSettings", "profileId", profileId);
            // verify required parameter 'puid' is not null or undefined
            assertParamExists("updateProfileSettings", "puid", puid);
            // verify required parameter 'settingsProfile' is not null or undefined
            assertParamExists("updateProfileSettings", "settingsProfile", settingsProfile);
            const localVarPath = `/v1/profiles/puid/{puid}/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"puid"}}`, encodeURIComponent(String(puid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter["Content-Type"] = "application/json";

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(settingsProfile, localVarRequestOptions, configuration);

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Activate a profile manually.
         * @param {string} profileId This parameter defines the ID of the profile, which is generated by server.
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfileStatus: async (profileId: string, puid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists("updateProfileStatus", "profileId", profileId);
            // verify required parameter 'puid' is not null or undefined
            assertParamExists("updateProfileStatus", "puid", puid);
            const localVarPath = `/v1/profiles/status/puid/{puid}/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"puid"}}`, encodeURIComponent(String(puid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * ProfileManagementAPIApi - functional programming interface
 * @export
 */
export const ProfileManagementAPIApiFp = function (configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfileManagementAPIApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Add a new profile
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {PredefinedSettingsProfile} predefinedSettingsProfile the detailed feature configuration in profile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProfileSettings(
            puid: string,
            predefinedSettingsProfile: PredefinedSettingsProfile,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addProfileSettings(puid, predefinedSettingsProfile, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["ProfileManagementAPIApi.addProfileSettings"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         *
         * @summary Delete a profile
         * @param {string} profileId This parameter defines the ID of the profile, which is generated by server.
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProfileSettings(
            profileId: string,
            puid: string,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProfileSettings(profileId, puid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["ProfileManagementAPIApi.deleteProfileSettings"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve the profile list
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfileList(
            puid: string,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PredefinedSettingsIdList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfileList(puid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["ProfileManagementAPIApi.getProfileList"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         *
         * @summary Get a profile content
         * @param {string} profileId This parameter defines the ID of the profile, which is generated by the  server.
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfileSettings(
            profileId: string,
            puid: string,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PredefinedSettingsProfile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfileSettings(profileId, puid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["ProfileManagementAPIApi.getProfileSettings"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         *
         * @summary Update a profile content
         * @param {string} profileId This parameter defines the ID of the profile, which is generated by server.
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {PredefinedSettingsProfile} settingsProfile settingsProfile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProfileSettings(
            profileId: string,
            puid: string,
            settingsProfile: PredefinedSettingsProfile,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfileSettings(profileId, puid, settingsProfile, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["ProfileManagementAPIApi.updateProfileSettings"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         *
         * @summary Activate a profile manually.
         * @param {string} profileId This parameter defines the ID of the profile, which is generated by server.
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProfileStatus(
            profileId: string,
            puid: string,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfileStatus(profileId, puid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["ProfileManagementAPIApi.updateProfileStatus"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    };
};

/**
 * ProfileManagementAPIApi - factory interface
 * @export
 */
export const ProfileManagementAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfileManagementAPIApiFp(configuration);
    return {
        /**
         *
         * @summary Add a new profile
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {PredefinedSettingsProfile} predefinedSettingsProfile the detailed feature configuration in profile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProfileSettings(puid: string, predefinedSettingsProfile: PredefinedSettingsProfile, options?: any): AxiosPromise<void> {
            return localVarFp.addProfileSettings(puid, predefinedSettingsProfile, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a profile
         * @param {string} profileId This parameter defines the ID of the profile, which is generated by server.
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfileSettings(profileId: string, puid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteProfileSettings(profileId, puid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve the profile list
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileList(puid: string, options?: any): AxiosPromise<PredefinedSettingsIdList> {
            return localVarFp.getProfileList(puid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a profile content
         * @param {string} profileId This parameter defines the ID of the profile, which is generated by the  server.
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileSettings(profileId: string, puid: string, options?: any): AxiosPromise<PredefinedSettingsProfile> {
            return localVarFp.getProfileSettings(profileId, puid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a profile content
         * @param {string} profileId This parameter defines the ID of the profile, which is generated by server.
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {PredefinedSettingsProfile} settingsProfile settingsProfile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfileSettings(profileId: string, puid: string, settingsProfile: PredefinedSettingsProfile, options?: any): AxiosPromise<void> {
            return localVarFp.updateProfileSettings(profileId, puid, settingsProfile, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Activate a profile manually.
         * @param {string} profileId This parameter defines the ID of the profile, which is generated by server.
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfileStatus(profileId: string, puid: string, options?: any): AxiosPromise<void> {
            return localVarFp.updateProfileStatus(profileId, puid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProfileManagementAPIApi - object-oriented interface
 * @export
 * @class ProfileManagementAPIApi
 * @extends {BaseAPI}
 */
export class ProfileManagementAPIApi extends BaseAPI {
    /**
     *
     * @summary Add a new profile
     * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
     * @param {PredefinedSettingsProfile} predefinedSettingsProfile the detailed feature configuration in profile.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileManagementAPIApi
     */
    public addProfileSettings(puid: string, predefinedSettingsProfile: PredefinedSettingsProfile, options?: RawAxiosRequestConfig) {
        return ProfileManagementAPIApiFp(this.configuration)
            .addProfileSettings(puid, predefinedSettingsProfile, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete a profile
     * @param {string} profileId This parameter defines the ID of the profile, which is generated by server.
     * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileManagementAPIApi
     */
    public deleteProfileSettings(profileId: string, puid: string, options?: RawAxiosRequestConfig) {
        return ProfileManagementAPIApiFp(this.configuration)
            .deleteProfileSettings(profileId, puid, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Retrieve the profile list
     * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileManagementAPIApi
     */
    public getProfileList(puid: string, options?: RawAxiosRequestConfig) {
        return ProfileManagementAPIApiFp(this.configuration)
            .getProfileList(puid, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get a profile content
     * @param {string} profileId This parameter defines the ID of the profile, which is generated by the  server.
     * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileManagementAPIApi
     */
    public getProfileSettings(profileId: string, puid: string, options?: RawAxiosRequestConfig) {
        return ProfileManagementAPIApiFp(this.configuration)
            .getProfileSettings(profileId, puid, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update a profile content
     * @param {string} profileId This parameter defines the ID of the profile, which is generated by server.
     * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
     * @param {PredefinedSettingsProfile} settingsProfile settingsProfile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileManagementAPIApi
     */
    public updateProfileSettings(profileId: string, puid: string, settingsProfile: PredefinedSettingsProfile, options?: RawAxiosRequestConfig) {
        return ProfileManagementAPIApiFp(this.configuration)
            .updateProfileSettings(profileId, puid, settingsProfile, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Activate a profile manually.
     * @param {string} profileId This parameter defines the ID of the profile, which is generated by server.
     * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileManagementAPIApi
     */
    public updateProfileStatus(profileId: string, puid: string, options?: RawAxiosRequestConfig) {
        return ProfileManagementAPIApiFp(this.configuration)
            .updateProfileStatus(profileId, puid, options)
            .then((request) => request(this.axios, this.basePath));
    }
}

/**
 * ProfileScheduleManagementAPIApi - axios parameter creator
 * @export
 */
export const ProfileScheduleManagementAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get the schedule activation logs
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleActivationLogs: async (puid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'puid' is not null or undefined
            assertParamExists("getScheduleActivationLogs", "puid", puid);
            const localVarPath = `/v1/schedules/log/puid/{puid}`.replace(`{${"puid"}}`, encodeURIComponent(String(puid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get profile schedules
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleSettings: async (puid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'puid' is not null or undefined
            assertParamExists("getScheduleSettings", "puid", puid);
            const localVarPath = `/v1/schedule/puid/{puid}`.replace(`{${"puid"}}`, encodeURIComponent(String(puid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update profile schedules
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {PredefinedSettingsSchedule} predefinedSettingsSchedule predefinedSettingsSchedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduleSettings: async (
            puid: string,
            predefinedSettingsSchedule: PredefinedSettingsSchedule,
            options: RawAxiosRequestConfig = {},
        ): Promise<RequestArgs> => {
            // verify required parameter 'puid' is not null or undefined
            assertParamExists("updateScheduleSettings", "puid", puid);
            // verify required parameter 'predefinedSettingsSchedule' is not null or undefined
            assertParamExists("updateScheduleSettings", "predefinedSettingsSchedule", predefinedSettingsSchedule);
            const localVarPath = `/v1/schedule/puid/{puid}`.replace(`{${"puid"}}`, encodeURIComponent(String(puid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter["Content-Type"] = "application/json";

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(predefinedSettingsSchedule, localVarRequestOptions, configuration);

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update the profile schedule status
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {SettingsScheduleStatus} scheduleStatus scheduleStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduleStatus: async (puid: string, scheduleStatus: SettingsScheduleStatus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'puid' is not null or undefined
            assertParamExists("updateScheduleStatus", "puid", puid);
            // verify required parameter 'scheduleStatus' is not null or undefined
            assertParamExists("updateScheduleStatus", "scheduleStatus", scheduleStatus);
            const localVarPath = `/v1/schedule/status/puid/{puid}`.replace(`{${"puid"}}`, encodeURIComponent(String(puid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter["Content-Type"] = "application/json";

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(scheduleStatus, localVarRequestOptions, configuration);

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * ProfileScheduleManagementAPIApi - functional programming interface
 * @export
 */
export const ProfileScheduleManagementAPIApiFp = function (configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfileScheduleManagementAPIApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get the schedule activation logs
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScheduleActivationLogs(
            puid: string,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PredefinedSettingsActivationLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScheduleActivationLogs(puid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["ProfileScheduleManagementAPIApi.getScheduleActivationLogs"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         *
         * @summary Get profile schedules
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScheduleSettings(
            puid: string,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PredefinedSettingsSchedule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScheduleSettings(puid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["ProfileScheduleManagementAPIApi.getScheduleSettings"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         *
         * @summary Update profile schedules
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {PredefinedSettingsSchedule} predefinedSettingsSchedule predefinedSettingsSchedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateScheduleSettings(
            puid: string,
            predefinedSettingsSchedule: PredefinedSettingsSchedule,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateScheduleSettings(puid, predefinedSettingsSchedule, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["ProfileScheduleManagementAPIApi.updateScheduleSettings"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         *
         * @summary Update the profile schedule status
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {SettingsScheduleStatus} scheduleStatus scheduleStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateScheduleStatus(
            puid: string,
            scheduleStatus: SettingsScheduleStatus,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateScheduleStatus(puid, scheduleStatus, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["ProfileScheduleManagementAPIApi.updateScheduleStatus"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    };
};

/**
 * ProfileScheduleManagementAPIApi - factory interface
 * @export
 */
export const ProfileScheduleManagementAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfileScheduleManagementAPIApiFp(configuration);
    return {
        /**
         *
         * @summary Get the schedule activation logs
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleActivationLogs(puid: string, options?: any): AxiosPromise<PredefinedSettingsActivationLog> {
            return localVarFp.getScheduleActivationLogs(puid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get profile schedules
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleSettings(puid: string, options?: any): AxiosPromise<PredefinedSettingsSchedule> {
            return localVarFp.getScheduleSettings(puid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update profile schedules
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {PredefinedSettingsSchedule} predefinedSettingsSchedule predefinedSettingsSchedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduleSettings(puid: string, predefinedSettingsSchedule: PredefinedSettingsSchedule, options?: any): AxiosPromise<void> {
            return localVarFp.updateScheduleSettings(puid, predefinedSettingsSchedule, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update the profile schedule status
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {SettingsScheduleStatus} scheduleStatus scheduleStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduleStatus(puid: string, scheduleStatus: SettingsScheduleStatus, options?: any): AxiosPromise<void> {
            return localVarFp.updateScheduleStatus(puid, scheduleStatus, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProfileScheduleManagementAPIApi - object-oriented interface
 * @export
 * @class ProfileScheduleManagementAPIApi
 * @extends {BaseAPI}
 */
export class ProfileScheduleManagementAPIApi extends BaseAPI {
    /**
     *
     * @summary Get the schedule activation logs
     * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileScheduleManagementAPIApi
     */
    public getScheduleActivationLogs(puid: string, options?: RawAxiosRequestConfig) {
        return ProfileScheduleManagementAPIApiFp(this.configuration)
            .getScheduleActivationLogs(puid, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get profile schedules
     * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileScheduleManagementAPIApi
     */
    public getScheduleSettings(puid: string, options?: RawAxiosRequestConfig) {
        return ProfileScheduleManagementAPIApiFp(this.configuration)
            .getScheduleSettings(puid, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update profile schedules
     * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
     * @param {PredefinedSettingsSchedule} predefinedSettingsSchedule predefinedSettingsSchedule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileScheduleManagementAPIApi
     */
    public updateScheduleSettings(puid: string, predefinedSettingsSchedule: PredefinedSettingsSchedule, options?: RawAxiosRequestConfig) {
        return ProfileScheduleManagementAPIApiFp(this.configuration)
            .updateScheduleSettings(puid, predefinedSettingsSchedule, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update the profile schedule status
     * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
     * @param {SettingsScheduleStatus} scheduleStatus scheduleStatus
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileScheduleManagementAPIApi
     */
    public updateScheduleStatus(puid: string, scheduleStatus: SettingsScheduleStatus, options?: RawAxiosRequestConfig) {
        return ProfileScheduleManagementAPIApiFp(this.configuration)
            .updateScheduleStatus(puid, scheduleStatus, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
